import { attr, belongsTo } from "@ember-data/model";
import type Patient from "parog-web/models/patient";
import { validateInclusion } from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import BaseSurgerySurveyFilledJournalEvent from "./base-surgery-survey-filled-journal-event";

type UsualTreatmentGuidelinesStringEnum = "0" | "1" | "2";

export default class PreSurgerySurveyFilledJournalEvent extends BaseSurgerySurveyFilledJournalEvent {
  static type = "pre-surgery-survey-filled-journal-event";

  @attr("string")
  declare usualTreatmentGuidelines: UsualTreatmentGuidelinesStringEnum;

  @attr("boolean")
  declare attendantForReturn: boolean;

  @attr("boolean")
  declare ambulatoryProcedure: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare trustPersonSurveyFilled: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare boughtPainkillersAndAntinauseant: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare hasAlertingValue: boolean;

  static validations(intl: IntlService) {
    return {
      ...this.baseValidations(intl),
      usualTreatmentGuidelines: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t(
          "validations.pre-surgery-survey-filled-journal-event.usual-treatment-guidelines"
        )
      })
    };
  }

  static sections = [
    "usualTreatmentGuidelines",
    "attendantForReturn",
    "ambulatoryProcedure",
    "trustPersonSurveyFilled",
    "boughtPainkillersAndAntinauseant"
  ];

  get sectionsWithColor() {
    const scoreValues = {
      usualTreatmentGuidelines: {
        "0": 0,
        "1": 10,
        "2": 0
      },
      attendantForReturn: {
        false: 0,
        true: 100
      },
      ambulatoryProcedure: {
        false: 0,
        true: 100
      },
      trustPersonSurveyFilled: {
        false: 0,
        true: 0
      },
      boughtPainkillersAndAntinauseant: {
        false: 0,
        true: 10
      }
    };

    return this.computeSectionsWithColor(
      PreSurgerySurveyFilledJournalEvent.sections,
      scoreValues
    );
  }

  @belongsTo("patient", {
    async: false,
    inverse: "preSurgerySurveyFilledJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "pre-surgery-survey-filled-journal-event": PreSurgerySurveyFilledJournalEvent;
  }
}
